import { lighten } from 'polished';

import { withTracker } from '@/tracker';
import { colors } from '@/themes';
import useNavbarBackground from '@/hooks/use-navbar-background';
import SEO from '@/components/seo';
import Hero from '@/components/careers/hero';
import Mission from '@/components/careers/mission';
import Openings from '@/components/careers/openings';

function About () {
  useNavbarBackground(lighten(.35, colors.brand.primary));

  return (
    <>
      <SEO
        title="Careers at Bidali"
        description="Find a career where you can impact the lives of millions around the world." />
      <Hero />
      <Mission />
      <Openings />
    </>
  );
}

export default withTracker(About);
